import { createAction } from '@ngrx/store';

export const dummy = createAction('[App] Dummy');
